import { render, staticRenderFns } from "./20_ap_tipo_embarques.vue?vue&type=template&id=f4e3c90c&scoped=true&"
import script from "./20_ap_tipo_embarques.vue?vue&type=script&lang=js&"
export * from "./20_ap_tipo_embarques.vue?vue&type=script&lang=js&"
import style0 from "./20_ap_tipo_embarques.vue?vue&type=style&index=0&id=f4e3c90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e3c90c",
  null
  
)

export default component.exports